import inView from 'in-view';
import jQueryBridget from 'jquery-bridget'
import Flickity from 'flickity'
import 'flickity-imagesloaded';
import 'flickity-fullscreen';

export default {
  init() {
    // JavaScript to be fired on all pages

    $('.btn-menu').on('click', function() {
      var $button = $(this);
      var $nav = $('.nav-primary');

      $button.toggleClass('btn-menu--active');
      $nav.toggleClass('nav-primary--active');
      $('.brand').toggleClass('menu-open');
      $('body').toggleClass('modal-open');
    });

    $('.nav-link').on('click', function() {
      $('body').removeClass('modal-open');
    });

    function subMenu() {
      if ( $(window).innerWidth() < 768 ) {
        $('.menu-item-has-children > a').on('click', function(e) {
          e.preventDefault();
          $(this).next('.sub-menu').toggleClass('submenu--active');
          $(this).parent('.menu-item-has-children').toggleClass('menu-item--active');
        });
      }
    }

    subMenu();

    $(window).bind('resize', function() {
      subMenu();
    });

    // Page Header height
    // $('.page-header').height($('.page-header').height());

    /** Banner Transition **/

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      if (scroll >= 20) {
          $('.banner').addClass('banner-fixed');
      } else {
        $('.banner').removeClass('banner-fixed');
      }
    });

    var contentGallery = $('.content-block-gallery').flickity({
      wrapAround: true,
      pageDots: false,
      autoPlay: 8000,
      draggable: false,
      imagesLoaded: true,
      prevNextButtons: false,
    });

    $('.content-block-gallery').on('click', function () {
      contentGallery.flickity('next', true);
    });

    /**
     * Ambient Video/Embedded Video Stuff
     */

    function resizeVideo(video) {
      if (video) {
        var container = $('.page-header .media-wrapper');

        if (container.length > 0) {
          var vidRatio = $(video).data('width') / $(video).data('height');
          var contRatio = $(container[0]).width() / $(container[0]).height();

          if (vidRatio > contRatio) {
            var width = $(container[0]).height() * vidRatio;
            var leftOffset = -(width - $(container[0]).width()) * 0.5;
            video.style.height = Math.floor($(container[0]).height()) + 'px';
            video.style.width = Math.floor(width) + 'px';
            video.style.left = leftOffset + 'px';
            video.style.top = '0px';
          } else {
            var height = $(container[0]).width() / vidRatio;
            var topOffset = -(height - $(container[0]).height()) * 0.5;
            video.style.width = Math.floor($(container[0]).width()) + 'px';
            video.style.height = Math.floor(height) + 'px';
            video.style.top = topOffset + 'px';
            video.style.left = '0px';
          }
        }
      }
    }

    // Set height to prevent wobble with vh
    // function setPageHeaderHeight() {
    //   var height = $(window).innerHeight() - 84;
    //   $('.page-header.has-media').height(height);
    // }

    // Save window width to see if it's the width that changed height
    // window.savedWidth = $(window).width();

    // setPageHeaderHeight();

    $('.page-header.has-media video').each(function () {
      resizeVideo($(this).get(0));
    });


    $(window).on('resize', function () {
      // Check if window width is different from stored value
      // if (window.savedWidth !== $(window).width()) {
      //   setPageHeaderHeight();
      //   window.savedWidth = $(window).height();
      // }
      $('.page-header.has-media video').each(function () {
        resizeVideo($(this).get(0));
      });
    });

    // Default to showing videos
    var playsInline = function () {
      var inlineVideo = true;

      // Do some conditional checking to see when we shouldn't show videos because they won't play inline
      if (navigator.userAgent.match(/CriOS/i) && 'playsInline' in document.createElement('video')) {
        // Chrome on iOS supports this now
        inlineVideo = true;
      } else if (navigator.userAgent.match(/CriOS/i)) {
        // But not older versions
        inlineVideo = false;
      } else if (navigator.userAgent.match(/((iPhone|iPod|iPad).*AppleWebKit(?!.*Version)|; wv)/i)) {
        // iOS or Android webviews
        inlineVideo = false;
      } else if (navigator.userAgent.match(/(\(iPod|\(iPhone|\(iPad)/i) && 'playsInline' in document.createElement('video')) {
        // This should be iOS 10 devces
        inlineVideo = true;
      } else if (navigator.userAgent.match(/(\(iPod|\(iPhone|\(iPad)/i)) {
        // This should be iOS devices less than iOS 10
        inlineVideo = false;
      }

      return inlineVideo;
    }

    function findVideo($element) {
      var $video;

      if ($element.is('video')) {
        $video = $element;
      } else {
        $video = $element.find('video');
      }

      return $video;
    }

    function setupVideoEvents() {
      var $videos = $('[data-play]');

      $videos.each(function () {
        var $video = findVideo($(this));

        if ( $video.length > 0 ) {
          var videoElement = $video.get(0);
          var fade = $video.data('fade');
          var notMobileFlag = $video.data('mobile');

          var videoOnMobile = $(window).innerWidth() < 768 && notMobileFlag;

          if ( playsInline() && ! videoOnMobile ) {
            // Videos are invisible by default so there's not a flash on mobile
            $video.removeClass('invisible');

            if (fade) {
              $video.on('timeupdate', function (e) {
                if ( (e.target.duration - 0.3 >= 0) && (e.target.duration - e.target.currentTime) <= 0.3 ) {
                  $('.page-header .media-wrapper').addClass('fade-to-image');
                  $(e.target).addClass('finished-playing');
                }
              });
            }

            if ($video.data('play') === 'hover') {
              // Play Video on hover
              $(this).hover(function () {
                videoElement.play();
              }, function () {
                videoElement.pause();
              });
            } else if ($video.data('play') === 'inview') {
              if ( !$video.hasClass('finished-playing') ) {
                inView('#' + videoElement.id)
                  .on('enter', function () {
                    videoElement.play();
                  })
                  .on('exit', function () {
                    videoElement.pause();
                  });
              }
            } else {
              videoElement.play();
            }
          } else {
            // If we can't play videos inline, just remove them
            $video.remove();
            $('.page-header .media-wrapper').addClass('fade-to-image');
          }
        }
      });
    }

    setupVideoEvents();

    // Smooth Scroll to Anchors //
    $('.anchor').on('click',function (e) {
      e.preventDefault();

      var target = this.hash;
      var $target = $(target);

      $('html, body').stop().animate({
        'scrollTop': $target.offset().top,
      }, 900, 'swing', function () {
        window.location.hash = target;
      });

    });

    $('.filter-top-bar-link').on('click', function() {
      $('.filter-top-bar-toggle-text').text($(this).text());
      $('.filter-top-bar-collapse').collapse('hide');
    });

    // Fullscreen Flickity Carousel on demand from gallery images
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);
    var fullscreenGalleryActive = false;

    $('.gallery-image').on('click', function() {
      if ( ! fullscreenGalleryActive ) {
        fullscreenGalleryActive = true;

        // Get the index of the slide the user clicked to init the carosel
        var imageIndex = $('.gallery-image').index(this);

        // A shiny new div for us to use
        var $fullscreenFlickity = $('<div class="gallery-fullscreen"/>');

        // If there's a click outside of the image, close fullscreen
        $fullscreenFlickity.on('staticClick.flickity', function(event, pointer, cellElement) {
          var $cellElement = $(cellElement)

          var windowWidth = $(window).width();
          var windowHeight = $(window).height();
          var windowRatio = ( windowHeight / windowWidth );

          var realHeight = windowHeight;
          var realWidth = windowWidth;

          var xPos = pointer.pageX - $cellElement.offset().left;
          var yPos = pointer.pageY - $cellElement.offset().top;

          var backgroundImage = $cellElement.css('background-image').replace(/url\((['"])?(.*?)\1\)/gi, '$2');

          $('<img/>').attr('src', backgroundImage).on('load', function() {

            var image = this;
            var imageWidth = image.width;
            var imageHeight = image.height;
            var imageRatio = ( imageHeight / imageWidth );

            // Clean up image element now we have its width/height
            $(this).remove();

            if (imageRatio > windowRatio) {
              realWidth = imageWidth * (windowHeight / imageHeight);
            } else {
              realHeight = imageHeight * (windowWidth / imageWidth);
            }

            var deadX = (windowWidth - realWidth) / 2;
            var deadY = (windowHeight - realHeight) / 2;

            if ( xPos < deadX || yPos < deadY || (xPos > windowWidth - deadX) || (yPos > windowHeight - deadY) ) {
              $fullscreenFlickity.flickity('exitFullscreen');
            }
          }).on('error', function() {
            // If we couldn't load the image, presume an empty view and close
            $fullscreenFlickity.flickity('exitFullscreen');
          });
        });

        // When exiting full screen, destroy flickity and remove the div entirely
        $fullscreenFlickity.on('fullscreenChange.flickity', function(event, isFullscreen) {
          if (!isFullscreen) {
            $fullscreenFlickity.flickity('destroy').remove();
            fullscreenGalleryActive = false;
          } else {
            // Fade in slider when showing
            $fullscreenFlickity.find('.flickity-slider').fadeTo('slow', 1);
          }
        });

        // Initialize flickity with fullscreen abilities
        $fullscreenFlickity.flickity({
          fullscreen: true,
        });

        $fullscreenFlickity
        .flickity('insert', $('.gallery-image').clone()) // Insert all the gallery images to the carousel
        .flickity('select', imageIndex, false, true) // Select the image the user clicked
        .insertBefore('.gallery') // Put it in the DOM
        .flickity('viewFullscreen'); // Start full screen
      }
    });

    // Mortgage popovers
    $('[data-mortgage-disclaimer]').popover({
      trigger: 'manual',
      content: window.mortgageDisclaimer,
    })
    .on('mouseenter', function () {
      var _this = this;
      $(this).popover('show');
      $('.popover').on('mouseleave', function () {
          $(_this).popover('hide');
      });
    }).on('mouseleave', function () {
        var _this = this;
        setTimeout(function () {
            if (!$('.popover:hover').length) {
                $(_this).popover('hide');
            }
        }, 300);
    });

    if($('.mortgage-calculator').length){

      $('.mortgage-calculator .popfield').on('change keyup', function(){
        var house_value = parseFloat($('#calc_price').val());
        var selections = parseFloat($('#calc_selections').val());
        //var tax = parseFloat($('#calc_gst').val());
        var downpayment_rate = parseFloat($('#calc_down_payment').val()) / 100; //might need infer, i.e., 10/100
        var rate = parseFloat($('#calc_mortgage_rate').val()); // annual rate of interest

        // CALCULATED
        var subtotal = house_value + selections;
        var tax = subtotal <= 350000
        ? subtotal*0.05*0.64 
        : subtotal <= 450000 
        ? subtotal*0.05 - (450000 - subtotal)/100000*6300
        : subtotal*0.05;
        var mortgage = house_value + selections + tax;
        var downpayment = mortgage * downpayment_rate;
        var principal = mortgage - downpayment;

        // LOAN CONDITION CONSTANTS (ALL INFERRED!!)
        const term = 25; // years
        const capitalizations = 2; // times compounding per year, i.e., semi-annual = 2

        $('#cal_gst').html('$ ' + numberWithCommas(tax.toFixed(2)));
        $('#cal_total').html('$ ' + numberWithCommas(mortgage.toFixed(2)));
        // MONTHLY: Note 12 for monthly
        $('#cal_monthly').html('$ ' + get_payment(capitalizations, rate, 12, principal, term));
        //Output: 1994.68
        // BI-WEEKLY: Note 26 for bi-weekly
        $('#cal_biweekly').html('$ ' + get_payment(capitalizations, rate, 26, principal, term));
        //Output: 919.64
      });

      $('.mortgage-calculator .popfield').first().trigger('change');
      
    }

    // MISSING INGREDIENT - NEED THE TRUE MONTHLY % RATE
    function effective_rate(Capitalizations, Apr, nPmtsPerYear) {
      return (1 + Apr / 100 / Capitalizations) ** (Capitalizations / nPmtsPerYear);
    }

    // MAIN FUNCTION: NOTE:: "nPmtsPerYear" controls Monthly (12) -vs- Bi-Weekly (26)
    function get_payment(Capitalizations, Apr, nPmtsPerYear, Principal, Term) {
      const EffectiveRate = effective_rate(Capitalizations, Apr, nPmtsPerYear);
      const payment =
        (EffectiveRate ** (nPmtsPerYear * Term) * (EffectiveRate - 1) * Principal) /
        (EffectiveRate ** (nPmtsPerYear * Term) - 1);

      return numberWithCommas(payment.toFixed(2)); //round to 2 places
    }

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js